import React from "react";
import autoBind from "react-autobind";
import Autocomplete from "react-google-autocomplete";
import _ from "lodash";

import { markdownToHtml } from "../../utils/markupUtils";
import { getLocationValueString, convertGoogleMapPlaceToValue } from "../../utils/utils";
import withPlayerItemHoc from "./PlayerItemHoc";
import DoneButton from "./DoneButton";
class PlayerAddress extends React.PureComponent {

	constructor(props) {
		super(props);
		this.readOnly = false;
		this.state = {
			value: this.props.item.value ? this.props.item.value : {}
		};
		autoBind(this);
	}

	onSubmit() {
		if (this.props.onSubmit) { this.props.onSubmit(this.state.value); }
	}

	onPlaceSelected(place) {
		const value = convertGoogleMapPlaceToValue(place);
		if (this.props.onChange) { this.props.onChange(value); }
		this.setState({ value: value });
	}

	render() {
		if (this.props.readOnly) {
			return this.renderReadOnly();
		} else {
			return this.renderEditable();
		}
	}

	renderReadOnly() {
		const { item, getImage, getVideo, getPdf } = this.props;

		let value = getLocationValueString(item.value);
		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		const component =
			<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
				<div style={{ width: "100%" }}>
					<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { readOnlyLinks: true })} />
					<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { readOnlyLinks: true })} />
					{getImage()}
					{getVideo()}
					{getPdf()}
					<div dangerouslySetInnerHTML={markdownToHtml(value)} />
				</div>
			</div>;

		return component;
	}

	renderEditable() {
		const { item, getImage, getVideo, getPdf, listIndex, sectionIndex, itemIndex, disabled } = this.props;

		let value = getLocationValueString(item.value);
		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;

		const addressSearchStyles = _.assign({ width: "100%" },_.get(theme, "item.addressSearch.text", {}));
		const panelStyles = _.assign({ marginBottom: "12px" }, _.get(theme, "item.addressSearch.panel", {}));

		const component =
			<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
				<div style={{ width: "100%" }}>
					<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { listIndex, sectionIndex, itemIndex })} />
					<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { listIndex, sectionIndex, itemIndex })} />
					{getImage()}
					{getVideo()}
					{getPdf()}
					<div style={panelStyles}>
						<div style={addressSearchStyles} dangerouslySetInnerHTML={markdownToHtml(value)} />
						<div>
							<Autocomplete
								className="form-control"
								style={addressSearchStyles}
								disabled={disabled}
								onPlaceSelected={this.onPlaceSelected}
								types={[]}
							/>
							</div>
					</div>	
					{!disabled && <DoneButton onSubmit={this.onSubmit} />}
				</div>
			</div>;

		return component;
	}
}

export default withPlayerItemHoc(PlayerAddress);